import { styled } from '@clickcease/cc-client-components-lib'

export const LargeAuthButton = styled('button', {
  all: 'unset',
  maxWidth: '487px',
  display: 'flex',
  width: '400px',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '$lg',
  height: '42px',
  fontWeight: '$sb',
  cursor: 'pointer',
  borderRadius: '4px',
  gap: '$2',

  background: '$primaryColor',
  color: '$white',
  '&:hover': {
    background: '$buttonHovered',
  },
  '&:active': {
    background: '$buttonPressed',
  },
  '&:disabled': {
    background: '$lightNeutral',
    cursor: 'not-allowed',
  },

  '@bp1': {
    width: '295px',
  },
})
